<template>
  <a
    class="link-container"
    :class="device.isMobile ? 'link-container-mobile' : ''"
    :id="content.key"
    :href="content.link"
    target="_blank"
    :style="{
      fontFamily: content.textStyle.fontFamily || '',
      fontSize: (content.textStyle.fontSize + 'rem') || '',
      lineHeight: (content.textStyle.lineHeight + 'rem') || '',
      textIndent: (typeof content.textStyle.textIndent === 'string') ? content.textStyle.textIndent :
        (typeof content.textStyle.textIndent === 'number') ? (content.textStyle.textIndent + 'rem') : '',
      fontWeight: content.textStyle.fontWeight || '',
      textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.textStyle.textAlign || '',
      color: content.textStyle.color || '',
      backgroundColor: content.textStyle.backgroundColor || '',
    }"
    @click.stop="(e)=> {
      findChapterFrom(e)
      e.stopPropagation();
    }"
  >
    <span :id="`${content.key}-1`">{{ content.text }}</span>
    <img
      :id="`${content.key}-2`"
      :src="content.linkIcon || require('@/assets/images/bookContent/bubble-icon-link.png')"
      alt=""
      class="link-icon" />
  </a>
</template>
<script>
/*
超链接
*/
export default {
  name: "text-link",
  inject: {
    findChapterFrom: {
      default: () => {},
    },
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.link-container{
  color: #0281EC;
  position: relative;
  cursor: pointer;
  word-break: keep-all;
  text-decoration: underline;
  
  .link-icon{
    width: 14rem;
    height: 14rem;
    display: inline;
    top: -10rem;
    position: relative;
  }
}
.link-container-mobile{
  .link-icon{
    width: 22rem;
    height: 22rem;
    top: -3rem;
  }
}
</style>